import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const _p = window.location.pathname;
if (_p === "/crm" || _p === "/crm/") {
  // Production hosts fall back to this (BC) index.html for the extensionless
  // /crm path; redirect to the real Reach CRM object so its SPA boots.
  window.location.replace("/crm/index.html" + window.location.search + window.location.hash);
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
